import { type UseQueryOptions, type UseQueryResult, useQuery } from '@tanstack/react-query';

import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';
import { filtersSelector } from '@/packages/redux-state/store/slices/jsonQuery';

import { type TMapGetBboxResponse_1 } from '@/repositories/generated/shared/search-offers-index/v2/map/get-bbox';

import { type QueryError, type QueryKey, getQueryKey } from './internal/config';
import { fetchMapGetBboxService } from './internal/fetchService';

type UseMapGetBboxQueryOptions<TData> = UseQueryOptions<TMapGetBboxResponse_1, QueryError, TData, QueryKey>;

export function useMapGetBboxQuery<TData = TMapGetBboxResponse_1>(
  options?: UseMapGetBboxQueryOptions<TData>,
): UseQueryResult<TData, QueryError> {
  const applicationContext = useQueryStateAppContext();
  const reduxState = useReduxState();

  return useQuery<TMapGetBboxResponse_1, QueryError, TData, QueryKey>({
    enabled: false,
    queryFn: () => {
      const jsonQuery = filtersSelector(reduxState.getState());

      return fetchMapGetBboxService({
        applicationContext,
        parameters: { jsonQuery },
      });
    },
    queryKey: getQueryKey(),
    retry: 1,
    staleTime: Infinity,
    ...options,
  });
}
